export default __webpack_public_path__ + "static/media/message.e475e229.png";